import React, { useEffect, useRef, useState } from 'react';
import confetti from 'canvas-confetti';
import { CONFETTI_LOGO_INTERVAL_MS } from '../../config/decoracion';
import './LogoMundial.css';

// Paleta celeste y blanco (bandera argentina)
const COLORS = ['#75AADB', '#4A90D9', '#A8D0EF', '#FFFFFF', '#FFFFFF'];
const PUB = process.env.PUBLIC_URL;
const GOL_MS = 4600; // duración del clip de festejo

const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Televisor visto DESDE ATRÁS (lo que mira el hincha). Vemos la carcasa
// trasera + el resplandor de la pantalla escapando por los bordes.
const TvSVG = () => (
  <svg className="tv-svg" viewBox="0 0 70 60" aria-hidden="true">
    {/* antena */}
    <line x1="35" y1="16" x2="24" y2="3" stroke="#555" strokeWidth="2" strokeLinecap="round" />
    <line x1="35" y1="16" x2="48" y2="4" stroke="#555" strokeWidth="2" strokeLinecap="round" />
    {/* resplandor de la pantalla escapando por los bordes */}
    <rect className="tv-glow" x="4" y="12" width="62" height="44" rx="8" fill="#cdeed4" />
    {/* carcasa trasera */}
    <rect x="9" y="15" width="52" height="38" rx="6" fill="#4a4a4a" stroke="#333" strokeWidth="1" />
    {/* rejillas de ventilación */}
    <g stroke="#5e5e5e" strokeWidth="2" strokeLinecap="round">
      <line x1="15" y1="22" x2="30" y2="22" />
      <line x1="15" y1="27" x2="30" y2="27" />
      <line x1="15" y1="32" x2="30" y2="32" />
    </g>
    {/* protuberancia central (cuello del CRT) */}
    <rect x="38" y="23" width="16" height="17" rx="3" fill="#3d3d3d" />
    {/* cable de poder */}
    <path d="M42 53 q 5 7 0 12 t 5 9" fill="none" stroke="#333" strokeWidth="1.6" strokeLinecap="round" />
    {/* patitas */}
    <rect x="17" y="53" width="5" height="5" rx="1" fill="#333" />
    <rect x="48" y="53" width="5" height="5" rx="1" fill="#333" />
  </svg>
);

// Hincha al lado del logo: mira expectante (idle) y festeja el gol
// cada 2 minutos o al pasar el mouse, disparando confetti.
const LogoMundial = () => {
  const ref = useRef(null);
  const [celebrating, setCelebrating] = useState(false);
  const lock = useRef(false);

  const fireConfetti = () => {
    const el = ref.current;
    if (!el || document.hidden) return;
    const r = el.getBoundingClientRect();
    if (!r.width) return;
    const x = (r.left + r.width / 2) / window.innerWidth;
    const y = (r.top + r.height / 2) / window.innerHeight;
    const common = {
      origin: { x, y },
      colors: COLORS,
      zIndex: 99999,
      disableForReducedMotion: true,
      ticks: 460, // viven más => caen por toda la pantalla
      gravity: 1.05,
    };
    confetti({ ...common, particleCount: 140, spread: 120, startVelocity: 62, angle: 75, drift: 1.2 });
    confetti({ ...common, particleCount: 90, spread: 165, startVelocity: 50, angle: 90, drift: 0.6 });
  };

  const celebrate = () => {
    if (lock.current || prefersReduced || document.hidden) return;
    lock.current = true;
    setCelebrating(true);
    // confetti cuando ya está festejando (no al principio del clip)
    setTimeout(fireConfetti, 2000);
    setTimeout(fireConfetti, 2800);
    setTimeout(() => {
      setCelebrating(false);
      lock.current = false;
    }, GOL_MS);
  };

  // Cada 2 minutos (CONFETTI_LOGO_INTERVAL_MS) festeja solo
  useEffect(() => {
    if (prefersReduced) return undefined;
    const id = setInterval(celebrate, CONFETTI_LOGO_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <span className="tv-logo" aria-hidden="true">
        <TvSVG />
      </span>
      <span className="hincha-logo" ref={ref} aria-hidden="true" onMouseEnter={celebrate}>
        <img
          src={`${PUB}/img/${celebrating ? 'hincha_gol.webp' : 'hincha_idle.png'}`}
          alt=""
          className={celebrating ? 'is-gol' : 'is-idle'}
        />
      </span>
    </>
  );
};

export default LogoMundial;
